<template>
	<div :style="pageCss">
		<!-- <dynamicPage
			v-if="mid && pageConfig"
			:route-params="route.query"
			:pconfig="pageConfig && pageConfig.page"
		/> -->
		<component v-if="pageConfig" :is="h5dynamicPage" :key=pageName :route-params="route.query"
			:pconfig="pageConfig" />
		<div v-else class="err">{{ pageConfig?  '暂无页面内容' : '正在加载中......' }}</div>
	</div>
</template>

<script lang="ts" setup>
import { onUnmounted, ref, computed, watchEffect } from 'vue';
import { useRoute } from 'vue-router';
// import dynamicPage from 'd3components/src/components/tdesign/contents_tdesign.vue';
// import { getDynByName } from 'd3components/src/components/dytemppage';
import h5dynamicPage from 'd3components/src/components/item-base/v_content.vue';
import { clearMenuComCache } from 'd3components';
import { pageConfigMap } from 'preferenceStore-utils';

// 定义 props
interface Props {
	tabIndex?: number;
	childPid?: string;
	// TabsItems 场景：每个 TabItem 直接把页面数据传进来（避免依赖 route.meta）
	page?: any;
	mid?: string | number;
}

const props = withDefaults(defineProps<Props>(), {
	tabIndex: undefined,
	childPid: undefined,
	page: undefined,
	mid: undefined,
});

const route = useRoute();

const pageName=	route.name;

const pageConfig = computed(() => pageConfigMap[`${route.meta.page}`]);

const pageCss =  pageConfig.value?.css || '';



onUnmounted(() => {
	clearMenuComCache(route as any);
});
</script>

<script lang="ts">
export default {
	name: 'GenericDyPage'
}
</script>

<style scoped lang="scss">
.err {
	// color: rgb(255, 0, 0);
	color: #333;
	line-height: 40px;
	text-align: center;
	background: #fff;
	display: block;
	padding: 18% 20%;
}

.debug-panel {
	position: fixed;
	top: 10px;
	right: 10px;
	background: rgba(0, 0, 0, 0.8);
	color: white;
	padding: 15px;
	border-radius: 8px;
	font-size: 12px;
	z-index: 9999;
	max-width: 300px;
}

.debug-panel h4 {
	margin: 0 0 10px 0;
	color: #ffd700;
}

.debug-panel p {
	margin: 5px 0;
}

.debug-panel button {
	background: #007bff;
	color: white;
	border: none;
	padding: 5px 10px;
	border-radius: 4px;
	cursor: pointer;
	margin-top: 10px;
}

.debug-panel button:hover {
	background: #0056b3;
}
</style>
